import { render, staticRenderFns } from "./Pendiente.vue?vue&type=template&id=78919dc9&scoped=true&lang=pug&"
import script from "./Pendiente.vue?vue&type=script&lang=js&"
export * from "./Pendiente.vue?vue&type=script&lang=js&"
import style0 from "./Pendiente.vue?vue&type=style&index=0&id=78919dc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78919dc9",
  null
  
)

export default component.exports